"use strict";
exports.__esModule = true;
exports.FieldNames = void 0;
exports.FieldNames = {
    reason_for_visit: 'reason for visit',
    work_queue_name: 'work queue',
    procedure_type: 'procedure type',
    procedure_category: 'procedure category',
    exam_type: 'exam type',
    exam_description: 'exam description',
    body_region: 'body part',
    raw_body: 'documentation'
};
//# sourceMappingURL=case.lang.js.map